import {Pipe, PipeTransform} from '@angular/core';

import {CountryCode, parsePhoneNumber, PhoneNumber} from "libphonenumber-js";

@Pipe({
    name: 'phoneNumber',
    standalone: false
})
export class PhoneNumberPipe implements PipeTransform {

    transform(phoneNumber: string, countryCode: CountryCode = 'MY'): PhoneNumber {
        // console.log("Pre transform phone number: ", phoneNumber);
        // console.log("Pre transform country code: ", countryCode);
        const parse = parsePhoneNumber(phoneNumber, countryCode);
        // console.log(parse);
        return parse;
    }
}
